'use strict';

class UsersEditController {
  constructor($log,
              $q,
              $rootScope,
              $scope,
              $filter,
              $state,
              $translate,
              utils,
              config,
              OrganizationService,
              SubscriptionsService,
              MessagingService,
              UsersService,
              PermissionsService,
              ToastsService,
              I18nService) {

    // #region Define fields

    const $t = $filter('translate');
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY = 'Selected-Subscription';
    const ORG_TAGS_LIST_PROPERTY = 'tags';
    const fallbackLanguage = I18nService.getLocale() ? I18nService.getLocale().code : 'en';

    // Prperty model for phone number
    const propertyModel = {
      phoneCode: null,
      phoneNumber: null,
    };

    $scope.userEditPage = {};

    const SELECTED_USER = utils.getStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY);
    const SELECTED_LOCATION = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);
    const LIMIT = 20;

    // Deprecated: convert admin role
    if (SELECTED_USER && SELECTED_USER.roleId) {
      SELECTED_USER.role = {
        id: SELECTED_USER.roleId
      };
    }

    let $userEditPage = $scope.userEditPage;
    $userEditPage.search = {};
    $userEditPage.userInfo = SELECTED_USER || {};
    $userEditPage.userInfoBack = angular.copy($userEditPage.userInfo);
    $userEditPage.userLocations = []; // This is all user locations
    $userEditPage.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY); // Selected org.
    $userEditPage.currentUser = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY).user; // Current user (logged in user)
    $userEditPage.organizations = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY); // All available orgs.
    $userEditPage.userSubscriptionStatus = '';
    $userEditPage.phoneTypes = config.getConfigByKey('phoneTypes');
    $userEditPage.smsStatuses = config.getConfigByKey('smsStatuses');
    $userEditPage.userAccessibilityTypes = config.getConfigByKey('userAccessibilityTypes');
    $userEditPage.userGenders = config.getConfigByKey('userGenders');

    // Custom phone validation
    $userEditPage.phoneError = '';
    $userEditPage.isSaveAttempt = false;

    // Subscription Types
    const subscriptionTypes = config.getConfigByKey('subscriptionTypes');

    // Notification Subscriptions
    const deliveryTypes = config.getConfigByKey('notificationDeliveryTypes');
    const sourceTypes = config.getConfigByKey('notificationSourceTypes');
    const locationAccessLevels = config.getConfigByKey('locationAccessLevels');
    const notificationTransport = config.getConfigByKey('notificationTransport');
    const notificationTypes = config.getConfigByKey('notificationTypes');
    var notificationSubscriptionsBack = []; // To test changes you've made
    $userEditPage.notificationSourceTypes = sourceTypes.filter(el => !el.hidden);
    $scope.datepickerButton = $('#toggle-datepicker');

    $userEditPage.isUnlimitedAdmin = PermissionsService.isUnlimitedAdmin();
    $userEditPage.isSuperAdmin = PermissionsService.isSuperAdmin();
    $userEditPage.isPaidAdmin = PermissionsService.isPaidAdmin();

    // Limit users search for merging
    $userEditPage.mergeLimit = 30;

    // Datepicker options for subscription modal
    $userEditPage.subscriptionDurationDatePickerOptions = {
      language: fallbackLanguage,
      position: 'bottom left',
      view: 'days',
      minView: 'days',
      autoClose: true,
      minDate: new Date(),
      dateFormat: 'm/dd/yyyy',
    };

    // Datepicker for birth date
    $userEditPage.birthDatePickerOptions = {
      language: fallbackLanguage,
      position: 'bottom left',
      view: $userEditPage.userInfoBack.birthDate ? 'days' : 'years',
      minView: 'days',
      autoClose: true,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      dateFormat: 'm/dd/yyyy',
      clearButton: $userEditPage.userInfoBack.birthDate ? false : true,
    };

    $userEditPage.userSubscriptionStatusMark = 3;
    $userEditPage.isCurrentUserPurchaseAdmin = false;

    $scope.loading = false;

    $scope.isViewModel = $state.current.name === 'main.users.view' && !PermissionsService.canIEditUser($userEditPage.userInfo);
    $scope.isUserAccessible = true;

    $scope.currentLocale = $translate.proposedLanguage() || $translate.use() || 'en';
    $scope.selection = ($state.params && $state.params.from) ? $state.params.from : void 0;

    $scope.timeFormatStr = $t('datetime.mdyHM12');
    $scope.notificationTimeFormat = $t('datetime.HMS12');
    $scope.notificationDateFormatStr = $t('datetime.events.date');
    $scope.datePickerDateTimeFormat = $t('datetime.scenes.datePickerDate');
    const TIMEZONE = moment.tz.guess() || 'GMT';

    // Navigation Tabs
    $scope.tabs = [
      {
        id: 'status',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      }, {
        id: 'subscriptions',
        name: $t('form.service-plans'),
        icon: 'far fa-scroll'
      },
      {
        id: 'locations',
        name: $t('menu.locations'),
        icon: 'far fa-map'
      },
      {
        id: 'tags',
        name: $t('form.tags'),
        icon: 'far fa-tag',
      },
      {
        id: 'notifications',
        name: $t('users.notifications.title'),
        icon: 'far fa-comment-lines'
      },
      {
        id: 'settings',
        name: $t('users.notifications.subscriptions'),
        icon: 'far fa-comment-check',
        hidden: true
      },
      {
        id: 'properties',
        name: $t('devices.info.properties'),
        icon: 'far fa-drafting-compass'
      },
      {
        id: 'delete',
        name: $t('user.edit.tabs.delete'),
        icon: 'far fa-user-slash',
        hidden: true
      },
      {
        id: 'signatures',
        name: $t('user.edit.tabs.signatures'),
        icon: 'far fa-file-signature',
        hidden: true
      }
    ];

    let notificationsLoaded = false;
    let subscriptionsLoaded = false;
    let notificationSubscriptionsLoaded = false;
    let propertiesLoaded = false;

    // #endregion

    // #region Put on scope only the stuff we really need there
    angular.extend($scope, {
      getMergeAndEditUsers: getMergeAndEditUsers,
      canMergeAndDeleteUser: canMergeAndDeleteUser,
      onMergeAndDeleteUserButtonClick: onMergeAndDeleteUserButtonClick,
      onApproveMergeAndDeleteButtonClick: onApproveMergeAndDeleteButtonClick,
      onDeleteUserButtonClick: onDeleteUserButtonClick,
      revokeAdminRole: revokeAdminRole,

      saveUserInfo: saveUserInfo,
      back: back,
      passwordReset: passwordReset,
      resetEmailStatus: resetEmailStatus,
      editUsername: editUsername,
      viewUser: viewUser,

      resetSmsStatus: resetSmsStatus,

      // Subscriptions
      viewSubscription: viewSubscription,
      getServiceColorMark: getServiceColorMark,
      getSubscriptionType: getSubscriptionType,

      // Locations
      canEditLocation: canEditLocation,
      editLocation: editLocation,
      generateAddress: generateAddress,
      getLocationOrgName: getLocationOrgName,

      // User Properties
      addProperty: addProperty,
      editProperty: editProperty,
      removeProperty: removeProperty,
      parsePropertyName: parsePropertyName,

      gotoSignatures: gotoSignatures,

      // User Notifications
      getUserNotifications: getUserNotifications,
      gotoNotificationSubscriptions: gotoNotificationSubscriptions,
      getNotificationIcon: getNotificationIcon,
      getNotificationSourceColor: getNotificationSourceColor,
      changeNotificationSubscription: changeNotificationSubscription,
      openUnsubscribeModal: openUnsubscribeModal
    });
    // #endregion

    // Put on $userEditPage instance only the stuff we really need there
    angular.extend($userEditPage, {
      getSubscriptionStatus: getSubscriptionStatus
    });

    // #region Main Functions ----------------------------

    function initPage() {

      // API calls separation at different navigation tabs
      $scope.$watch('activeTab', function(newValue, oldValue) {
        switch (newValue) {
          case 'subscriptions':
            if (!subscriptionsLoaded) {
              initSubscriptionsTab();
            }
            break;
          case 'notifications':
            if (!notificationsLoaded) {
              initNotificationsTab();
            }
            break;
          case 'settings':
            if (!notificationSubscriptionsLoaded) {
              initNotificationSubscriptionsTab();
            }
            break;
          case 'properties':
            if (!propertiesLoaded) {
              initPropertiesTab();
            }
            break;
        }
      });

      // Scroll to top when user selected
      $scope.$watch('targetUser', function(newValue, oldValue) {
        if (newValue) {
          $('html, body').animate({
            scrollTop: 0
          }, 500);
        }
      });

      $scope.$watch('userEditPage.userInfo.phoneCode', (newValue, oldValue) => {
        if (!$userEditPage.isSaveAttempt) {
          return;
        }
        if (newValue !== oldValue) {
          triggerFormValidation();
        }
      });

      $('#new-subscription-modal').modal({
        closable: true,
        detachable: true,
        autofocus: false
      });

      $('#edit-property-modal').modal({
        closable: false,
        detachable: true,
        autofocus: false,
        onShow: () => {
          initPropertyForm();

          /*
           * To avoid additional complexity with form validation,
           * we're not allowing to change display type of existing properties.
           */
          if ($userEditPage.selectedProperty.new) {
            $scope.$watch('userEditPage.selectedPropertyTemplateId', function(newValue, oldValue) {
              if (newValue) {
                let selectedPropertyTemplate = $userEditPage.propertyTemplates.find(t => t.id === newValue);
                $userEditPage.selectedProperty.displayType = selectedPropertyTemplate && selectedPropertyTemplate.displayType;

                // Additional phone number
                if (selectedPropertyTemplate.displayType === 51) {
                  $userEditPage.selectedProperty.name = selectedPropertyTemplate.template || null;
                  $userEditPage.selectedProperty.model.phoneCode = angular.copy($userEditPage.userInfo.phoneCode);
                  initPropertyForm(selectedPropertyTemplate.displayType);
                }
              } else {
                // Reset property model to default
                $userEditPage.selectedProperty.name = null;
                $userEditPage.selectedProperty.value = null;
                $userEditPage.selectedProperty.displayType = null;
                $userEditPage.selectedProperty.model = angular.copy(propertyModel);
                initPropertyForm();
              }
            });
          } else {
            if ($userEditPage.selectedProperty.displayType) {
              initPropertyForm(angular.copy($userEditPage.selectedProperty.displayType))
            }
          }

        },
        onApprove: () => {
          $('#property-form').form('validate form');
          if (!$('#property-form').form('is valid')) {
            return false;
          }

          // Parse phone number value
          if ($userEditPage.selectedProperty.displayType === 51) {
            $userEditPage.selectedProperty.value = $userEditPage.selectedProperty.model.phoneCode.toString() + $userEditPage.selectedProperty.model.phoneNumber.toString();
          }

          return updateUserProperty($userEditPage.selectedProperty.name, $userEditPage.selectedProperty.value, $userEditPage.selectedProperty.displayType);
        },
        onDeny: () => {
          $userEditPage.selectedProperty = null;
          $userEditPage.selectedPropertyTemplateId = null;
        }
      });

      $('#unsubscribe-modal').modal({
        closable: true,
        detachable: true,
        autofocus: false,
        onApprove: () => {
          return unsubscribeFromNotifications();
        }
      });

      // Remove modals
      $scope.$on('$destroy', () => {
        $('#new-subscription-modal').remove();
        $('#edit-property-modal').remove();
        $('#unsubscribe-modal').remove();
        $('#password-reset-dialog').remove();
        $('#merge-and-delete-dialog').remove();
        $('#delete-user-modal').remove();
        $('#revoke-role-dialog').remove();
      });

      $.fn.form.settings.rules.searchEmailRule = function(value) {
        if (!$userEditPage.checkSearchEmail) {
          return true;
        } else {
          return $.fn.form.settings.rules.email(value);
        }
      };

      $.fn.form.settings.rules.phoneCode = function(value) {
        if (!!$userEditPage.userInfo.phoneNumber || !!$userEditPage.userInfo.phoneCode) {
          if (!$userEditPage.userInfo.phoneCode || $userEditPage.userInfo.phoneCode === '0' || !/^[0-9]{1,3}$/gi.test($userEditPage.userInfo.phoneCode)) {
            return false;
          }
        }
        return true;
      };

      $.fn.form.settings.rules.phoneNumber = function(value) {
        if (!!$userEditPage.userInfo.phoneNumber || !!$userEditPage.userInfo.phoneCode) {

          if (!$userEditPage.userInfo.phoneNumber || !/^[0-9]{7,14}$/gi.test($userEditPage.userInfo.phoneNumber)) {
            return false;
          }

          return $.fn.form.settings.rules.phoneValidation(
            $userEditPage.userInfo.phoneNumber,
            JSON.stringify({
              code: $userEditPage.userInfo.phoneCode.toString(),
              type: $userEditPage.selectedPhoneType && $userEditPage.selectedPhoneType.id
            })
          );
        }
        return true;
      };

      $.fn.form.settings.rules.propertyPhoneCode = function(value) {
        if (!!$userEditPage.selectedProperty.model.phoneNumber || !!$userEditPage.selectedProperty.model.phoneCode) {
          if (!$userEditPage.selectedProperty.model.phoneNumber || $userEditPage.selectedProperty.model.phoneCode === '0' || !/^[0-9]{1,3}$/gi.test($userEditPage.selectedProperty.model.phoneCode)) {
            return false;
          }
        }
        return true;
      };

      $.fn.form.settings.rules.propertyPhoneNumber = function(value) {
        if (!!$userEditPage.selectedProperty.model.phoneNumber || !!$userEditPage.selectedProperty.model.phoneCode) {
          if (!$userEditPage.selectedProperty.model.phoneNumber || !/^[0-9]{7,14}$/gi.test($userEditPage.selectedProperty.model.phoneNumber)) {
            return false;
          }
          return $.fn.form.settings.rules.phoneValidation(
            $userEditPage.selectedProperty.model.phoneNumber,
            JSON.stringify({
              code: $userEditPage.selectedProperty.model.phoneCode.toString(),
            })
          );
        }
        return true;
      };

      $.fn.form.settings.rules.emptyIfAdmin = function(value) {
        return !!$userEditPage.userInfo.role
          ? $.fn.form.settings.rules.empty(value)
          : true;
      };

      $.fn.form.settings.rules.emptyIfExist = function(value, id) {
        return !!$userEditPage.userInfoBack[id]
          ? $.fn.form.settings.rules.empty(value)
          : true;
      };

      $('#form-tags-add').form({
        inline: true,
        fields: {
          tags: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.tags.empty')
              }
            ]
          }
        }
      });

      $('#form-search').form({
        inline: true,
        keyboardShortcuts: false,
        fields: {
          searchEmail: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.email.your')
              }, {
                type: 'searchEmailRule',
                prompt: $t('prompt.email.invalid')
              }
            ]
          }
        }
      });

      $('#form-details').form({
        on: 'blur',
        inline: true,
        keyboardShortcuts: false,
        fields: {
          'username': {
            rules: [
              {
                type: 'emptyIfExist[username]',
                prompt: $t('prompt.empty')
              }
            ]
          },
          'altUsername': {
            rules: [
              {
                type: 'emptyIfExist[altUsername]',
                prompt: $t('prompt.empty')
              }
            ]
          },
          'email': {
            optional: true,
            identifier: 'email',
            rules: [
              {
                type: 'emptyIfAdmin',
                prompt: $t('users.new.errors.noEmail')
              },
              {
                type: 'email',
                prompt: $t('prompt.email.invalid')
              }
            ]
          },
          'code': {
            depends: 'phone',
            rules: [
              {
                type: 'phoneCode',
                prompt: $t('prompt.signup.phone.code')
              }
            ]
          },
          'phone': {
            identifier: 'phone',
            rules: [
              {
                type: 'phoneNumber',
                prompt: $t('prompt.signup.phone.invalid')
              }
            ]
          },
          'birthDate': {
            rules: [
              {
                type: 'emptyIfExist[birthDate]',
                prompt: $t('prompt.empty')
              }
            ]
          }
        }
      });

      function initPropertyForm(displayType) {
        let fields = {
          'property-name': {
            identifier: 'property-name',
            rules: [
              {
                type: 'regExp[/^[A-Za-z0-9._\-]{1,32}$/]',
                prompt: $t('users.edit.validate')
              }
            ]
          },
        };

        // Add phone number validation
        if (displayType && displayType === 51) {
          fields['property-phone-code'] = {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.empty')
              },
              {
                type: 'propertyPhoneCode',
                prompt: $t('prompt.signup.phone.code')
              }
            ]
          };
          fields['property-phone-number'] = {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.empty')
              },
              {
                type: 'propertyPhoneNumber',
                prompt: $t('prompt.signup.phone.invalid')
              }
            ]
          };
        } else {
          fields['property-value'] = {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.empty')
              }
            ]
          };
        }

        $('#property-form').form({
          inline: true,
          keyboardShortcuts: false,
          fields: fields,
        });
      }

      initPropertyForm();

      $scope.loading = true;
      $scope.subscriptionsLoading = true;

      initUserData(true)
        .then(() => $q.all([
          getOrgTagsToInitUserBadges(),
          getUserProperties(),
          getLanguages(),
        ]))
        .then(() => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
        });
    }

    function back() {
      if ($scope.activeTab === 'delete') {
        $scope.activeTab = 'status';
        return;
      }
      if ($scope.selection) {
        switch ($scope.selection) {
          case 'participants':
            let challengeId = $state.params && $state.params.challengeId;
            $rootScope.$emit('refreshChooseMenuEvent', 'challenges');
            $state.go('main.challenges.demand', { id: challengeId, tab: 'participants' });
            return;
          case 'location':
            $rootScope.$emit('refreshChooseMenuEvent', 'locations');
            $state.go('main.locations.edit', { tab: 'users' });
            return;
          case 'organization':
            $rootScope.$emit('refreshChooseMenuEvent', 'organizations');
            $state.go('main.organizations.edit', {
              tab: $state.params && $state.params.fromTab ? $state.params.fromTab : 'admins'
            });
            return;
          case 'notification':
            $rootScope.$emit('refreshChooseMenuEvent', 'notifications');
            $state.go('main.notifications.info', { tab: 'relations' });
            return;
          case 'notifications':
            $rootScope.$emit('refreshChooseMenuEvent', 'notifications');
            $state.go('main.notifications.groups.edit');
            return;
          case 'callcenter':
            if (SELECTED_LOCATION) {
              if ($state.params && SELECTED_LOCATION.id === parseInt($state.params.locationId)) {
                $rootScope.$emit('refreshChooseMenuEvent', 'callcenter');
                $state.go('main.callcenter.edit', { from: 'location', locationId: $state.params.locationId });
                return;
              } else {
                $rootScope.$emit('refreshChooseMenuEvent', 'locations');
                $state.go('main.locations.edit');
                return;
              }
            }
        }
        $state.go('main.users.list');
      }
      $state.go('main.users.list');
    }

    function getLanguages() {
      UsersService.getSupportedLanguages()
        .then(data => {
          $scope.userLanguages = data;
        });
    }

    // #endregion

    // #region User Info Tab -----------------------------

    function updateUserInfo(userInfo) {
      const organizationId = $userEditPage.orgInfo ? $userEditPage.orgInfo.id : void 0;

      return UsersService.updateUserInfo(userInfo.user, $userEditPage.userInfo.id, organizationId)
        .then(data => {
          $scope.loading = false;
          ToastsService.success();
          initUserData();
        }, err => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function editUsername() {
      $('#username').attr('readonly', false).trigger('focus');
    }

    /**
     * Phone number validation
     */
    function triggerFormValidation() {
      $('#form-details').form('validate form');
    }

    /**
     * Saves changed user info and contacts
     */
    function saveUserStatus() {
      triggerFormValidation();
      if (!$('#form-details').form('is valid')) {
        $userEditPage.isSaveAttempt = true;
        return $q.reject('Form is not valid');
      }

      // Set back readonly attribute at username field
      $('#username').attr('readonly', true);
      $userEditPage.userInfo.userName = $userEditPage.userInfo.username;

      // Set selected accessibility types
      let accessibilityTypes = [];
      if ($userEditPage.selectedAccessibilityTypes && $userEditPage.selectedAccessibilityTypes.length > 0) {
        $userEditPage.selectedAccessibilityTypes.forEach(at => {
          accessibilityTypes.push(at.id);
        });
      }

      let userInfo = {
        'username': $userEditPage.userInfo.username,
        'altUsername': $userEditPage.userInfo.altUsername,
        'email': $userEditPage.userInfo.email ? $userEditPage.userInfo.email.email : null,
        'firstName': $userEditPage.userInfo.firstName,
        'lastName': $userEditPage.userInfo.lastName,
        'phoneType': $userEditPage.userInfo.phoneType || 1, // Mobile if it's not defined None if it's not defined
        'accessibility': utils.packValuesToBitmask(accessibilityTypes || 0), // No accessibility by defauilt
        'language': $userEditPage.userInfo.language || fallbackLanguage,
        'birthDate': $userEditPage.selectedBirthDate && $userEditPage.selectedBirthDate.toISOString().split('T')[0],
        'gender': $userEditPage.userInfo.gender || 0,
      };

      // Save phone number only if it's not blank
      userInfo['phone'] = $userEditPage.userInfo.phoneNumber
        ? $userEditPage.userInfo.phoneCode.toString() + $userEditPage.userInfo.phoneNumber.toString()
        : '';

      // Check if anything was changed at all
      let isEmailSame = ($userEditPage.userInfoBack && $userEditPage.userInfoBack.email && $userEditPage.userInfoBack.email.email === userInfo.email) || (!$userEditPage.userInfoBack.email && userInfo.email === null)
        ? true
        : false;
      let isUserInfoSame = isEmailSame && $userEditPage.userInfoBack && utils.compareObjects(userInfo, $userEditPage.userInfoBack, [
        'username',
        'altUsername',
        'firstName',
        'lastName',
        'phone',
        'phoneType',
        'accessibility',
        'language',
        'birthDate',
        'gender',
      ]);

      if (isUserInfoSame) {
        return $q.resolve('Nothing changed');
      }

      $scope.loading = true;
      return updateUserInfo({
        user: userInfo
      });
    }

    function getOrgTagsToInitUserBadges() {
      return OrganizationService.getObjectOrProperty($userEditPage.orgInfo.id, ORG_TAGS_LIST_PROPERTY)
        .then(property => {
          if (property && property.value != null) {

            // Get org badges enumerated as tags values comma separated on the Organization (property)
            let orgBadges = property.value.split(',').filter(badge => badge && badge.length !== 0);

            // Show to the user as a badges only those tags, that correspond to the ones mentioned on the Organization itself
            $userEditPage.userBadges =
              ($userEditPage.userInfo.tags || []).filter(t => !t.organizationId && !t.appId && orgBadges.indexOf(t.tag) !== -1).map(t => t.tag);
          }
        }, err => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    /**
     * Saves user data by click on button
     */
    function saveUserInfo() {
      switch ($scope.activeTab) {
        case 'status':
          saveUserStatus();
          break;
      }
    }

    function resetEmailStatus() {
      return UsersService.updateUserInfo({
        emailResetStatus: true
      }, $userEditPage.userInfo.id).then(
        () => {
          $userEditPage.userInfo.email.status = 0;
          $userEditPage.isSaveAttempt = false;
          initUserData();
        }, err => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function resetSmsStatus() {
      $scope.loading = true;
      return UsersService.updateUserInfo({ smsResetStatus: true }, $userEditPage.userInfo.id)
        .then(
          () => {
            $scope.loading = false;
            $scope.hideResetSmsStatusButton = true;
            // $userEditPage.userInfo.smsStatus = 0;
            initUserData();
          }, err => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
    }

    /**
     * Main function to initiate gathering user info
     */
    function initUserData(initial) {
      $userEditPage.step = 2;

      return UsersService.getUserInfo($userEditPage.userInfoBack.id)
        .then(data => {
          let user = angular.copy(data.user);

          if (user.phone) {
            const phoneInfo = utils.parsePhoneNumber(user.phone);
            if (phoneInfo.phoneNumber) {
              angular.extend(user, phoneInfo);
            }
          }

          user.username = user.userName;

          if (data.locations && data.locations.length > 0) {
            processLocations(data.locations);
          }

          if (!user.language) {
            user.language = fallbackLanguage;
          }

          // Check if user editable on initial call
          if (initial) {
            $scope.isViewModel = !isUserAccessible(data.user, data.locations);
            utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
          }

          // Email can't be blank for admins
          if ((!!user.email && !!user.email.email) || !!user.role) {
            // Semantic UI dynamic rules
            $('#form-details').form('add rule', 'email', {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.email.valid')
                }
              ]
            });
            $('#email-field').addClass('required');
          }

          // Work with date of birth
          if (user.birthDate) {
            $userEditPage.selectedBirthDate = new Date(user.birthDate);
          }

          // Set default gender
          if (!user.gender) {
            user.gender = 0; // Unknown
          }

          $scope.$applyAsync(() => {
            // Add abnormal user's email status text
            if (user.email && user.email.status !== 0) {
              $userEditPage.emailStatusText = $t('users.edit.emailStatusDesc', { status: $t('users.emailStatuses.' + user.email.status) });
            }

            $userEditPage.userInfo = user;
            $userEditPage.userInfoBack = angular.copy($userEditPage.userInfo);
            $userEditPage.selectedPhoneType = user.phoneType && user.phoneType > 0
              ? $userEditPage.phoneTypes[user.phoneType - 1]
              : $userEditPage.phoneTypes[0];

            // Parse accessibility type bitmask
            $userEditPage.selectedAccessibility = [];
            let parsedAccessibility = utils.unpackBitmask(user.accessibility || []);
            if (parsedAccessibility && parsedAccessibility.length > 0) {
              parsedAccessibility.forEach(at => {
                let type = $userEditPage.userAccessibilityTypes.find(t => t.id === at);
                if (type) {
                  $userEditPage.selectedAccessibility.push(type.id.toString());
                }
              });
            }

          });
        })
        .then(() => {
          // Only Admin's with permission "5" or "8" can assign paid plans within Maestro,
          // all others can't assign plans if they are not allowed for free assignment in
          // specific organization which will returned by servicePlans API with organizationId parameter.
          $scope.$applyAsync(() => {
            $userEditPage.isCurrentUserPurchaseAdmin = PermissionsService.isPaidAdmin() || PermissionsService.isServiceAdmin();
          });
        })
        .catch(err => {
          // Disable editing user if got API error
          $scope.isViewModel = true;
          // Fix username field data
          $userEditPage.userInfo.username = angular.copy($userEditPage.userInfo.userName);
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    /**
     * Check your admin access rights depends of selected user
     * You still can get locations that is not in one of available organizations
     */
    function isUserAccessible(user, locations) {
      // Check if user data accessible
      $scope.isUserAccessible = PermissionsService.canIAccessUserData(locations);
      return PermissionsService.canIEditUser(user);
    }

    function passwordReset() {
      $('#password-reset-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: function() {
            $scope.$applyAsync(() => {
              doResetPassword();
            });
          }
        }).modal('show');
    }

    function doResetPassword() {
      let brand = $userEditPage.orgInfo ? $userEditPage.orgInfo.brand : void 0;
      return UsersService.resetPassword($userEditPage.userInfo.username, brand)
        .then(
          () => {
            ToastsService.success(null, $t('common.reset-user-password-success'));
          },
          err => {
            if (err && err.resultCodeMessage) {
              $scope.loading = false;
              $scope.subscriptionsLoading = false;
              utils.handleApiError(err);
            } else {
              ToastsService.error(null, $t('common.reset-user-password-fail'));
            }
          })
        .catch(() => {
          ToastsService.error(null, $t('common.reset-user-password-fail'));
        });
    }

    function getSubscriptionStatus() {
      // User considered a free user if he has no current or old subscriptions
      if ((!$userEditPage.subscriptions || $userEditPage.subscriptions.length === 0) &&
        (!$userEditPage.oldSubscriptions || $userEditPage.oldSubscriptions.length === 0)) {
        $userEditPage.userSubscriptionStatusMark = 3;
        return $t('subscriptions.free');
      }
      // If user has an actual subscription, so the name of the first one's plan
      if ($userEditPage.subscriptions && $userEditPage.subscriptions.length > 0) {
        $userEditPage.userSubscriptionStatusMark = 0;

        // Get the active actual subscription endDate to show on label
        $userEditPage.userSubscriptionEndDate = $userEditPage.subscriptions[0].endDate;

        return $userEditPage.subscriptions[0].plan.desc; // top one is the one with largest endDate
      }
      // If user has only old subscription, show that info (if its cancelled or expired)
      if ($userEditPage.oldSubscriptions && $userEditPage.oldSubscriptions.length > 0) {
        //top one is the one with largest endDate
        let mostRecentOld = $userEditPage.oldSubscriptions[0];
        if (mostRecentOld.cancelled) {
          $userEditPage.userSubscriptionStatusMark = 1;
          $userEditPage.userSubscriptionEndDate = $userEditPage.oldSubscriptions[0].cancelDate;
          return $t('subscriptions.subscriptionCancelledLabel');
        } else {
          $userEditPage.userSubscriptionStatusMark = 2;
          $userEditPage.userSubscriptionEndDate = $userEditPage.oldSubscriptions[0].endDate;
          return $t('subscriptions.subscriptionExpiredLabel');
        }
      }
    }

    /**
     * Revoke administrative role
     * Availabvle only for admins with permission 1 (roles management)
     */
    function revokeAdminRole() {
      $('#revoke-role-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: function() {
            $scope.$applyAsync(() => {
              $scope.loading = true;
              return OrganizationService.revokeAdminRole($userEditPage.userInfo.id)
                .then(() => {
                  ToastsService.success(null, $t('orgs.new.admins.removeDesc'));
                  $scope.loading = false;
                  initUserData(true);
                }, err => {
                  $scope.loading = false;
                  utils.handleApiError(err);
                });
            });
          }
        }).modal('show');
    }

    /**
     * Get countries for the calling code field
     */
    // function getCountries() {
    //   LocationsService.getCountries()
    //     .then(data => {
    //       if (data && data.countries.length > 0) {
    //         $userEditPage.countries = data.countries.map(country => {
    //           try {
    //             let code = libphonenumber.getCountryCallingCode(country.countryCode);
    //             country.callingCode = code || '';
    //           } catch (e) {
    //             country.callingCode = '';
    //           }
    //           return country;
    //         }).filter(country => country.callingCode !== '');
    //       }
    //     });
    // }

    // #endregion

    // #region Merge and Delete User (Hidden Tab) --------

    function canMergeAndDeleteUser() {
      if ($userEditPage.userInfo.id === $userEditPage.currentUser.id) {
        return false;
      }
      return PermissionsService.canIDeleteAndMergeUser($userEditPage.userInfo);
    }

    function isUserEditable(user) {
      return PermissionsService.canIEditUser(user);
    }

    function onMergeAndDeleteUserButtonClick() {
      $scope.activeTab = 'delete';
    }

    function getMergeAndEditUsers(searchTerm) {
      $userEditPage.mergeAndEditUsersLoading = true;
      return UsersService.getUsersByParams(void 0, {
        searchBy: searchTerm + '*',
        limit: $userEditPage.mergeLimit
      })
        .then((data) => {
          $userEditPage.mergeAndEditUsersLoading = false;
          $userEditPage.mergeAndEditUserList = void 0;
          $scope.targetUser = void 0;
          if (data && data.users) {
            $userEditPage.mergeAndEditUserList = data.users
              .filter(u => {
                return u.id !== $userEditPage.currentUser.id
                  && u.id !== $userEditPage.userInfo.id
                  && PermissionsService.canIEditUser(u);
              });
            return $userEditPage.mergeAndEditUserList;
          }
        }, (err) => {
          $userEditPage.mergeAndEditUsersLoading = false;
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function onApproveMergeAndDeleteButtonClick() {
      $('#merge-and-delete-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: () => {
            $scope.$applyAsync(() => {
              mergeAndDeleteUser();
            });
          }
        })
        .modal('show');
    }

    function mergeAndDeleteUser() {
      let userToDelete = $userEditPage.userInfo;
      let userToMergeTo = $scope.targetUser;
      if (!userToDelete || !userToMergeTo) {
        return;
      }
      $scope.loading = true;
      return UsersService.mergeAndDeleteUser(userToDelete.id, userToMergeTo.id)
        .then(() => {
          $scope.loading = false;
          ToastsService.success(null, $t('users.edit.mergeAndDeleteSuccess', {
            id: userToDelete.id,
            targetId: userToMergeTo.id
          }));
          $state.go('main.users.list');
        }, (err) => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function onDeleteUserButtonClick() {
      $('#delete-user-modal')
        .modal({
          closable: false,
          detachable: true,
          onApprove: () => {
            $scope.$applyAsync(() => {
              deleteUser();
            });
          }
        })
        .modal('show');
    }

    function deleteUser() {
      let userToDelete = $userEditPage.userInfo;
      if (!userToDelete) {
        return;
      }
      $scope.loading = true;
      return UsersService.deleteUser(userToDelete.id)
        .then(() => {
          $scope.loading = false;
          ToastsService.success(null, $t('users.edit.deleteSuccess', {
            id: userToDelete.id
          }));
          $state.go('main.users.list');
        }, (err) => {
          $scope.loading = false;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function viewUser(user) {
      if (!user) {
        return;
      }
      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
      $rootScope.$emit('refreshChooseMenuEvent', 'users');
      if (isUserEditable(user)) {
        $state.go('main.users.edit', {}, {
          reload: true
        });
      } else {
        $state.go('main.users.view', {}, {
          reload: true
        });
      }
    }

    // #endregion

    // #region User Tags Tab -----------------------------

    $scope.$on('deleteTagsCompleteEvent', function(event, data) {
      event.preventDefault();
    });
    $scope.$on('addTagsCompleteEvent', function(event, data) {
      event.preventDefault();
      if (data.resultCode != 0) {
        return;
      }
      initUserData();
    });

    // #endregion

    // #region Subscriptions Tab -------------------------

    function initSubscriptionsTab() {
      getServicePlans();
    }

    function getServicePlans() {
      $scope.subscriptionsLoading = true;
      return SubscriptionsService.getUserSubscriptions($userEditPage.userInfo.id)
        .then((data) => {
          let plans = data.subscriptions || [];
          $userEditPage.subscriptions = plans.filter(s => s.status === 0 && s.userId === $userEditPage.userInfo.id);
          $userEditPage.oldSubscriptions = plans.filter(s => s.status === 1 && s.userId === $userEditPage.userInfo.id);
          subscriptionsLoaded = true;
          $scope.subscriptionsLoading = false;
        }, (err) => {
          subscriptionsLoaded = true;
          $scope.subscriptionsLoading = false;
          utils.handleApiError(err);
        });
    }

    function viewSubscription(subscription) {
      utils.setStorageItem(SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY, subscription);
      $state.go('main.subscriptions.edit', {
        'from': 'user',
        'userId': $userEditPage.userInfo.id,
        'userPlanId': subscription.userPlanId
      });
      $rootScope.$emit('refreshChooseMenuEvent', 'subscriptions');
    }

    function getServiceColorMark(service) {
      let now = new Date().getTime();
      if (service.startDateMs && now <= service.startDateMs || service.endDateMs && now >= service.endDateMs) {
        return 'red-mark';
      }
      if (!service.startDateMs && !service.endDateMs) {
        return 'grey-mark';
      }
      return 'green-mark';
    }

    function getSubscriptionType(type) {
      let unknownType = $t('subscriptions.unknownType');
      if (typeof type !== 'number') {
        return unknownType;
      }
      let result = subscriptionTypes.find(el => el.id === type);
      if (!result) {
        return unknownType;
      }
      return $t(result.name);
    }

    // #endregion

    // #region Locations Tab -----------------------------

    function canEditLocation(location) {
      if (!location) {
        return false;
      }
      return PermissionsService.canIEditLocation(location);
    }

    /**
     * Go to location edit UI
     */
    function editLocation(location) {
      if (!location || !location.organizationId) {
        return;
      }
      utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
      $state.go('main.locations.edit', {
        locationId: location.id,
        from: 'user',
        userId: $userEditPage.userInfo.id
      });
    }

    function processLocations(locations) {
      let otherLocations = [];
      let adminLocations = locations.filter(loc => {
        if (loc.locationAccess !== 30) {
          otherLocations.push(loc);
        }
        return loc.locationAccess === 30;
      });
      notificationSubscriptionsLoaded = false;
      $userEditPage.allLocations = locations;
      $userEditPage.userLocations = adminLocations;
      $userEditPage.otherLocations = otherLocations;
    }

    function generateAddress(location) {
      let address = utils.generateAddress(location);
      if (!address) {
        return $t('common.unknown-address');
      }
      return address;
    }

    function getLocationOrgName(location) {
      if (!location || !location.organizationId) {
        return $t('locations.list.notAtOrg');
      }
      let org = $userEditPage.organizations.find(element => {
        return location.organizationId === element.id;
      });
      if (org && org.name) {
        return $t('locations.list.atOrg', { name: org.name });
      } else {
        return $t('common.unknownOrganization');
      }
    }

    // #endregion

    // #region Properties Tab ----------------------------

    function initPropertiesTab() {
      $userEditPage.propertyTemplates = config.getConfigByKey('userPropertyTemplates');

      propertiesLoaded = true;
    }

    function getUserProperties() {
      // Can't get properties if user not editable or not accessible
      if ($scope.isViewModel || !$scope.isUserAccessible) {
        return;
      }

      $scope.loading = true;
      return UsersService.getUserProperties(undefined, $userEditPage.userInfo.id)
        .then(data => {
          $userEditPage.userProperties = data.properties
            ? data.properties.filter(el => (el.value || el.value === 0 || el.value === ''))
            : [];
          $scope.loading = false;
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function updateUserProperty(name, value, type) {
      let properties = [
        {
          name: name,
          value: value,
        },
      ];

      // Seleted property template
      if (type) {
        properties[0].displayType = type;
      }

      return UsersService.saveUserProperties(properties, $userEditPage.userInfo.id)
        .then(data => {
          ToastsService.success();
          return getUserProperties();
        }, err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function addProperty() {
      $userEditPage.selectedProperty = {
        new: true,
        name: null,
        value: null,
        displayType: null,
        model: angular.copy(propertyModel),
      };

      $('#edit-property-modal').modal('show');
    }

    function editProperty(property, $event) {
      $userEditPage.selectedProperty = {
        name: parsePropertyName(property.name),
        value: property.value,
        displayType: property.displayType,
      };

      // Define property display type
      if (property.displayType) {
        const propertyTemplate = $userEditPage.propertyTemplates.find(el => el.displayType === property.displayType);
        if (propertyTemplate && propertyTemplate !== -1) {
          $userEditPage.selectedPropertyTemplateId = propertyTemplate.id;

          // Parse phone number
          if (property.displayType === 51) {
            $userEditPage.selectedProperty.model = utils.parsePhoneNumber(property.value);
          }
        }
      } else {
        $userEditPage.selectedPropertyTemplateId = null;
      }

      $('#edit-property-modal').modal('show');
    }

    function removeProperty(property, $event) {
      if (property) {
        property.name = parsePropertyName(property.name);
        $userEditPage.selectedProperty = property;
      }
      if (!$userEditPage.selectedProperty || !$userEditPage.selectedProperty.name) {
        return;
      }
      $scope.loading = true;
      return updateUserProperty($userEditPage.selectedProperty.name);
    }

    function parsePropertyName(propertyName) {
      return propertyName.replace('ppc.api.', '');
    }

    // #endregion

    // #region User Notifications Tab --------------------

    function initNotificationsTab() {
      $scope.notificationsDate = null;
      initUserNotifications();
      getUserNotifications();

      $scope.notificationsDatePickerOptions = {
        language: fallbackLanguage,
        position: 'bottom left',
        autoClose: true,
        view: 'days',
        minView: 'days',
        dateFormat: $scope.datePickerDateTimeFormat,
        maxDate: new Date(),
        timepicker: false,
        clearButton: true,
        range: true,
        // toggleSelected: false
      };
    }

    function initUserNotifications() {
      $scope.$watchGroup([
        'selectedNotificationType',
        'notificationsDate'
      ], (newValue, oldValue) => {
        if ($scope.notificationsLoading) {
          return;
        }
        if (newValue[0] === oldValue[0] && utils.compareArrays(oldValue[1], newValue[1])) {
          return;
        }
        $userEditPage.userNotifications = [];
        return getUserNotifications(false);
      });
    }

    function getUserNotifications(loadMore) {
      $scope.notificationsLoading = true;
      $userEditPage.hasMoreNotifications = false;
      let params = {
        userId: $userEditPage.userInfo.id,
        rowCount: LIMIT,
        firstRow: 0
      };

      if ($scope.selectedNotificationType) {
        params.sourceType = $scope.selectedNotificationType;
      }

      // If datepicker is not blank
      if ($scope.notificationsDate && $scope.notificationsDate.length > 0) {
        params.startDate = moment.tz(moment($scope.notificationsDate[0])
          .format('L'), 'L', TIMEZONE)
          .startOf('day')
          .valueOf();

        if (!loadMore || !$userEditPage.userNotifications || $userEditPage.userNotifications.length === 0) {
          let endDateTemp = $scope.notificationsDate[$scope.notificationsDate.length - 1];
          params.endDate = moment.tz(moment(endDateTemp)
            .format('L'), 'L', TIMEZONE)
            .endOf('day')
            .valueOf();
        }
      } else { // Otherwise get data for last 24 hours
        params.startDate = new Date().getTime() - 24 * 60 * 60 * 1000;
      }

      // We take endDate as the newest timestamp to make next "Page"
      if (loadMore && $userEditPage.userNotifications && $userEditPage.userNotifications.length > 0) {
        params.endDate = $userEditPage.userNotifications[$userEditPage.userNotifications.length - 1].sendDateMs;
      }

      return MessagingService.getNotifications(params)
        .then(data => {
          if (data && data.notifications && data.notifications.length > 0) {
            $userEditPage.userNotifications = loadMore
              ? [...$userEditPage.userNotifications, ...data.notifications]
              : data.notifications;
            $userEditPage.hasMoreNotifications = data.notifications.length === LIMIT && data.collectionTotalSize > LIMIT;
          }
          $scope.notificationsLoading = false;
          notificationsLoaded = true;
        }, err => {
          $scope.notificationsLoading = false;
          utils.handleApiError(err);
        });
    }

    function gotoNotificationSubscriptions() {
      $scope.activeTab = 'settings';
    }

    // TODO move up
    let signaturesLoaded = false;

    function gotoSignatures() {
      $scope.activeTab = 'signatures';

      if (signaturesLoaded) {
        return;
      }
      initUserSignatures();
    }

    function initUserSignatures() {
      $scope.signaturesLoading = true;
      return UsersService.getSignatures($userEditPage.userInfo.id)
        .then((data) => {
          $userEditPage.signatures = data.termsOfServices || [];
          $scope.signaturesLoading = false;
          signaturesLoaded = true;
        }, (err) => {
          utils.handleApiError(err);
        });
    }

    function getNotificationIcon(deliveryType) {
      let result = deliveryTypes.find(el => el.id === deliveryType);
      return result?.icon;
    }

    function getNotificationSourceColor(sourceType) {
      let result = sourceTypes.find(el => el.id === sourceType);
      return result.color + '-mark';
    }

    // #endregion

    // #region Notification Subscriptions (Hidden Tab)

    function initNotificationSubscriptionsTab() {
      $scope.settingsLoading = true;
      $scope.settingsUpdating = false;
      $userEditPage.unsubscribeTypes = notificationTransport;
      // Add color and check name
      let allLocations = $userEditPage.allLocations || [];
      $userEditPage.allLocations.forEach((location, index) => {
        let accessLevel = locationAccessLevels.find(el => el.id === location.locationAccess);
        allLocations[index].color = accessLevel ? accessLevel.color : 'grey';
        if (!location.name) {
          allLocations[index].name = $t('common.unknownLocation');
        }
      });
      $userEditPage.allLocations = allLocations;
      $scope.selectedNotificationsLocationId = allLocations[0].id;

      // Only Unlimited Admins may edit general notification subscriptions
      if (!$userEditPage.isUnlimitedAdmin) {
        $scope.selectedUnsubscribeLocationId = angular.copy(allLocations[0].id);
      }

      getNotificationSubscriptions();
    }

    function getNotificationSubscriptions() {
      return MessagingService.getNotificationSubscriptions($userEditPage.userInfo.id)
        .then(data => {
          let results = data.subscriptions || [];
          let enrichedResults = results.map((el, index) => {
            el.index = index;
            el.selectedKeys = [];
            let type = notificationTypes.find(type => type.id === el.type) || [];

            // Enrich available transport types
            type.transport = getNotificationTransport(type.transport);

            // Set selected transport types
            type.transport.forEach(val => {
              el[val.id] && el.selectedKeys.push(val.id);
            });

            return { ...el, ...type };
          });
          $userEditPage.notificationSubscriptions = enrichedResults;
          notificationSubscriptionsBack = angular.copy(enrichedResults);
          $scope.settingsLoading = false;
          $scope.settingsUpdating = false;
          notificationSubscriptionsLoaded = true;
        }, err => {
          $scope.settingsLoading = false;
          $scope.settingsUpdating = false;
          utils.handleApiError(err);
        });
    }

    function updateNotificationSubscription(data, unsubscribe, isLast) {
      let params = {
        userId: $userEditPage.userInfo.id,
        locationId: data.locationId || void 0
      };

      // Check exact subscription types to subscribe/unsubscribe
      let selectedType = notificationTypes.find(el => el.id === data.type) || [];
      selectedType.transport.forEach(el => {
        let isExist = data.selectedKeys.includes(el.id);
        if (unsubscribe) {
          if (isExist) {
            params[el.id] = false;
          }
        } else {
          params[el.id] = isExist;
        }
      });

      return MessagingService.setNotificationSubscriptions(data.type, params)
        .then(res => {
          if (unsubscribe) {
            // Update notification subscriptions
            isLast && getNotificationSubscriptions();
            return;
          }
          notificationSubscriptionsBack = angular.copy($userEditPage.notificationSubscriptions);
          $scope.settingsUpdating = false;
        }, err => {
          $scope.settingsUpdating = false;
          utils.handleApiError(err);
        });
    }

    function openUnsubscribeModal() {
      $('#unsubscribe-modal').modal('show');
    }

    /* Unsubscribe from some types of notifications */
    function unsubscribeFromNotifications() {
      if (!$scope.selectedUnsubscribeTypeIds || $scope.selectedUnsubscribeTypeIds.length === 0) {
        return;
      }

      let settings = [];
      $scope.settingsUpdating = true;

      // Unsubscribe from all
      if (!$scope.selectedUnsubscribeLocationId) {
        let temp = $userEditPage.notificationSubscriptions.find(el => el.type === 0);
        if (temp) { // We have that option from API
          temp.selectedKeys = $scope.selectedUnsubscribeTypeIds;
          settings.push(temp);
        }
        // Unsubscribe from all types for selected Location
      } else {
        let tempArr = $userEditPage.notificationSubscriptions.filter(el => {
          if (el.locationId === $scope.selectedUnsubscribeLocationId) {
            el.selectedKeys = $scope.selectedUnsubscribeTypeIds;
            return true;
          }
        });
        settings = tempArr;
      }

      if (settings.length > 0) {
        settings.forEach((el, index) => {
          let last = index === settings.length - 1;
          updateNotificationSubscription(el, true, last);
        });
        return;
      }
      $scope.settingsUpdating = false;
    }

    /* Crazy on-change the multi-dropdowns */
    function changeNotificationSubscription(data) {
      if ($scope.settingsLoading || $scope.settingsUpdating || !data) {
        return;
      }

      $scope.settingsUpdating = true;
      setTimeout(() => { // As $scope updating have some lag
        let backup = notificationSubscriptionsBack[data.index];
        let current = $userEditPage.notificationSubscriptions[data.index];
        let test = utils.compareArrays(current.selectedKeys, backup.selectedKeys);
        if (!test) {
          return updateNotificationSubscription(data);
        }

        $scope.$applyAsync(() => {
          $scope.settingsUpdating = false;
        });

      }, 1);
    }

    /* Returns a list of enriched transport types */
    function getNotificationTransport(data) {
      let result = [];
      if (data && data.length > 0) {
        data.forEach(el => {
          // It's because of the .map at the getNotificationSubscriptions
          let enriched = el.id ? el : notificationTransport.find(val => val.id === el);
          result.push(enriched);
        });
      }
      return result;
    }

    // #endregion

    initPage();
  }
}

export default angular
  .module('main.usersEdit.controller', [])
  .controller('UsersEditController', UsersEditController)
  .name;
